import ReactModal from 'react-modal';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ChatroomLandingPage() {
  const navigate = useNavigate();
  const state = useLocation().state as {
    redirectTo: string;
    isStarted: boolean;
  };

  const [t] = useTranslation(['common', 'chatroom']);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (!state) {
      navigate('/chatrooms');
      return;
    }

    if (state && state.isStarted) {
      window.location.assign(state.redirectTo);
    } else {
      setOpenModal(true);
    }
  }, [navigate, state]);

  return (
    <ReactModal
      isOpen={openModal}
      overlayClassName="z-[51] fixed bg-black/[.4] inset-0 backdrop-blur-sm"
      className="flex h-full w-full justify-center items-center px-5"
    >
      <div className="bg-white flex flex-col p-6 w-full">
        <div className="flex flex-col w-full h-full justify-center items-center gap-6">
          <span className="text-center">
            {t(
              'wait_activity_activated',
              '組長尚未啟動活動，待活動啟動後即可進入'
            )}
          </span>
          <Link
            className="bg-group-primary text-white p-2 w-2/5 rounded text-center"
            to="/chatrooms"
          >
            {t('okay', '好', { ns: 'common' })}
          </Link>
        </div>
      </div>
    </ReactModal>
  );
}
